const TEAMS_THEME_PREFIX = 'teams$';

export function generateTeamsThemeId(baseThemeId: string) {
    return `${TEAMS_THEME_PREFIX}${baseThemeId}`;
}

export function isTeamsThemeId(themeId: string) {
    return themeId.startsWith(TEAMS_THEME_PREFIX);
}
